export enum OneClickBuilderField {
  Jobsite = 'jobsite',
  Payment = 'payment',
  Plant = 'plant',
  PointOfDelivery = 'pointOfDelivery',
  Product = 'product',
  Quantity = 'quantity',
  ReceivingPerson = 'receivingPerson',
  StandardLot = 'standardLot',
  Unit = 'unit',
  Time = 'time',
  TimeWIndow = 'timeWindow',
  PurchaseOrder = 'purchaseOrder',
}
